module.exports = __webpack_public_path__ + "img/flags/JM.f82c626.png";